// extracted by mini-css-extract-plugin
export var buttonIconWrapper = "_aq-4";
export var collapsed = "_aq-1";
export var headerBar = "_aq-0";
export var leftHeaderContent = "_aq-3";
export var subjectContainer = "_aq-2";